import React from "react";
interface NestedListItem {
  text: React.ReactNode;
}

interface ListItem {
  title: string;
  description: React.ReactNode;
  nestedItems?: NestedListItem[]; // Додаємо вкладений список
}

interface HeadingContent {
  type: "heading";
  text: string;
}

interface ParagraphContent {
  type: "paragraph";
  text: React.ReactNode;
}

interface ListContent {
  type: "list";
  items: ListItem[];
}

type Content = HeadingContent | ParagraphContent | ListContent;

const parseDefaultNotice = (text: string): Content[] => {
  const lines = text.split("\n");
  const structuredContent: Content[] = [];
  let currentList: ListItem[] | null = null;
  let currentNestedList: NestedListItem[] | null = null;
  let lastListItem: ListItem | null = null;

  const processText = (input: string): React.ReactNode => {
    const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
    const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;

    let result: React.ReactNode[] = [input];

    result = result.flatMap((part) => {
      if (typeof part !== "string") return part;
      const parts: React.ReactNode[] = [];
      let lastIndex = 0;
      let match;

      while ((match = linkRegex.exec(part)) !== null) {
        const [fullMatch, linkText, url] = match;
        const startIndex = match.index;

        if (startIndex > lastIndex) {
          parts.push(part.slice(lastIndex, startIndex));
        }
        parts.push(
          <a key={`${url}-${startIndex}`} href={url}>
            {linkText}
          </a>
        );
        lastIndex = startIndex + fullMatch.length;
      }

      if (lastIndex < part.length) {
        parts.push(part.slice(lastIndex));
      }
      return parts.length ? parts : part;
    });

    result = result.flatMap((part) => {
      if (typeof part !== "string") return part;
      const parts: React.ReactNode[] = [];
      let lastIndex = 0;
      let match;

      while ((match = emailRegex.exec(part)) !== null) {
        const email = match[0];
        const startIndex = match.index;

        if (startIndex > lastIndex) {
          parts.push(part.slice(lastIndex, startIndex));
        }
        parts.push(
          <a key={`${email}-${startIndex}`} href={`mailto:${email}`}>
            {email}
          </a>
        );
        lastIndex = startIndex + email.length;
      }

      if (lastIndex < part.length) {
        parts.push(part.slice(lastIndex));
      }
      return parts.length ? parts : part;
    });

    return result.length === 1 ? result[0] : result;
  };

  lines.forEach((line) => {
    line = line.trim();
    if (!line) return;

    // Обробка вкладених елементів (○)
    if (line.startsWith("○")) {
      if (!currentList || !lastListItem) {
        // Якщо немає основного списку або останнього елемента, ігноруємо
        return;
      }
      if (!currentNestedList) {
        currentNestedList = [];
        lastListItem.nestedItems = currentNestedList; // Прив'язуємо вкладений список до останнього елемента
      }
      const nestedItemText = line.slice(2).trim(); // Видаляємо ○
      currentNestedList.push({
        text: processText(nestedItemText),
      });
      return;
    }

    // Якщо був вкладений список, завершуємо його
    if (currentNestedList) {
      currentNestedList = null;
    }

    // Обробка основних елементів списку (●)
    if (line.startsWith("●")) {
      if (!currentList) currentList = [];
      const listItem = line.slice(2).trim();
      const [title, ...description] = listItem.split(" – ");
      lastListItem = {
        title: title || "",
        description: processText(
          description.length ? description.join(" – ") : ""
        ),
      };
      currentList.push(lastListItem);
      return;
    }

    // Завершення списку, якщо він був
    if (currentList) {
      structuredContent.push({ type: "list", items: currentList });
      currentList = null;
      lastListItem = null;
    }

    // Обробка заголовків (||)
    if (line.startsWith("||")) {
      const headingText = line.slice(2).trim();
      structuredContent.push({
        type: "heading",
        text: `${processText(headingText)}`,
      });
      return;
    }

    // Обробка параграфів
    structuredContent.push({ type: "paragraph", text: processText(line) });
  });

  // Завершення списку, якщо залишився незакритий
  if (currentList) {
    structuredContent.push({ type: "list", items: currentList });
  }

  return structuredContent;
};

export default parseDefaultNotice;
